module.exports = __webpack_public_path__ + "static/points-git-e58d77de6feb0772957b27ddd3b127c2.png";